import { IUserModel } from "@/models";
import { IValidationRules } from "@elite/validation";

import IAppState from "../IAppState";
import AppGetterTypes from "./AppGetterTypes";
import { GetPropertyValidationRules } from "./GetPropertyValidationRules";
import IAppGetterTree from "./IAppGetterTree";

const getters: IAppGetterTree = {
    version(state: IAppState): string {
        return state.version;
    },

    environmentAlert(state: IAppState): string {
        return state.environmentAlert;
    },

    validationRules(state: IAppState): IValidationRules {
        return state.validationRules;
    },

    getModelValidationRules: (state: IAppState) => (modelName: string) => {
        return state.validationRules[modelName];
    },

    getPropertyValidationRules: (state: IAppState) => (expression: string) => {
        const rulesNameParts = expression.split(".");
        const modelType = rulesNameParts[0];
        const propertyName = rulesNameParts[1];

        return state.validationRules[modelType][propertyName];
    },

    user(state: IAppState): IUserModel | undefined {
        return state.user;
    },

    isAuthenticated(state: IAppState): boolean {
        return state.user !== undefined;
    },

    isAdmin(state: IAppState): boolean {
        return state.user?.role === state.roleValues?.administrator;
    }
};

export default getters;

export { AppGetterTypes, GetPropertyValidationRules };
